import { useTranslation } from 'react-i18next'

import { TimerecordActions } from './TimerecordActions'
import { ActivityType } from '../../const'

interface TimeEntryCellProps {
  hours: number
  activityType?: string
  description?: string
  onEdit: () => void
  onCopy: () => void
  onDelete: () => void
  onInfo: () => void
  onAdd: () => void
}

const MAX_DESCRIPTION_LENGTH = 20

const truncateDescription = (description: string) =>
  description.length > MAX_DESCRIPTION_LENGTH
    ? `${description.slice(0, MAX_DESCRIPTION_LENGTH)}...`
    : description

export const TimeEntryCell = ({
  hours,
  activityType,
  description,
  onEdit,
  onCopy,
  onDelete,
  onInfo,
  onAdd,
}: TimeEntryCellProps) => {
  const { t } = useTranslation()

  return (
    <div className="time-entry-cell-with-actions time-entry-cell-inner">
      <div className="time-entry-content time-record-cell">
        <div className="time-entry-hours">{hours}h</div>
        {activityType && activityType !== ActivityType.BILLABLE && (
          <div
            className={`time-entry-badge ${activityType === ActivityType.SUPPORT ? 'time-entry-badge--info' : ''}`}
          >
            {t(`timeTracking.activityTypes.${activityType}`)}
          </div>
        )}
        {description && (
          <div className="time-entry-badge time-entry-badge--description">
            {truncateDescription(description)}
          </div>
        )}
      </div>
      <TimerecordActions
        onInfo={onInfo}
        onCopy={onCopy}
        onEdit={onEdit}
        onDelete={onDelete}
        onAdd={onAdd}
      />
    </div>
  )
}
